// @flow

import styled from 'styled-components'

import { Text } from '@alphaott/smart-tv-components'
import { getColorSlightPrimary } from '@alphaott/smart-tv-themes'

const getCardBackgroundColor = (props) => {
  if (props.focused) {
    return getColorSlightPrimary(props)
  }

  return 'transparent'
}

export const ChannelCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${getCardBackgroundColor};
  padding: 0 32rem;
`

export const ChannelCardTitleBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16rem;
`

export const ChannelCardTitle = styled(Text)`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
  font-size: 33rem;
  line-height: 40rem;
`

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & svg {
    width: 48rem;
    height: 48rem;
  }
`
